<h2 mat-dialog-title>{{ (data.name ? 'FOLDER_RENAME' : 'FOLDER_NEW') | transloco }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'FOLDER_NAME' | transloco }}</mat-label>
    <input matInput [formControl]="nameControl" (keydown.enter)="confirm()" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="null">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="primary" [disabled]="nameControl.invalid" (click)="confirm()">
    {{ 'SAVE' | transloco }}
  </button>
</mat-dialog-actions>
